/* eslint-disable import/no-cycle */
import { IInvoice } from './invoice';
import { ITransaction } from './transaction';

export enum PaymentMethod {
  CHECK = 'CHECK',
  ACH = 'ACH',
  CREDIT_CARD = 'CREDIT_CARD',
  CASH = 'CASH',
}

export interface IPayment {
  id: string;
  createdAt: string;
  method: PaymentMethod;
  reference: string;
  amount: number;
  transaction: ITransaction;
  invoice: IInvoice;
}
